import { HttpClient } from '../../httpClient'
import type {
  AnnotationLayout,
  CreateContentVersionAnnotationBody,
  ReadContentVersionAnnotationDocument,
} from './types'

/**
 * Creates a pin annotation at a fractional position on the given version, in the
 * coordinate space of the preview `layout` it was placed on.
 */
export const createContentVersionAnnotation = async ({
  versionUuid,
  x,
  y,
  layout,
  comment,
}: {
  versionUuid: string
  x: number
  y: number
  layout: AnnotationLayout
  comment: string
}): Promise<ReadContentVersionAnnotationDocument> => {
  const url = new URL('/v3/content_version_annotations', window.location.origin)

  const body: CreateContentVersionAnnotationBody = {
    data: {
      type: 'content_version_annotation',
      attributes: { x, y, layout, comment },
      relationships: {
        content_version: {
          data: { id: versionUuid, type: 'content_version' },
        },
      },
    },
  }

  return HttpClient()
    .post(url.toString(), body)
    .then((res) => res.data)
}
